import React from "react";
import { useNavigate } from "react-router-dom";
import { Home, Library, Disc3, Guitar } from "lucide-react";
import { useI18n } from "@/i18n/I18nContext";

const TABS = [
  { id: "home", navKey: "home", to: "/", icon: Home, testId: "nav-home-btn" },
  { id: "library", navKey: "library", to: "/library", icon: Library, testId: "nav-library-btn" },
  { id: "jam", navKey: "jam", to: "/library", icon: Guitar, testId: "nav-jam-btn", primary: true },
  { id: "my-jams", navKey: "myJams", to: "/my-jams", icon: Disc3, testId: "nav-my-jams-btn" },
];

interface AppShellProps {
  active: string;
  children: React.ReactNode;
}

export const AppShell: React.FC<AppShellProps> = ({ active, children }) => {
  const navigate = useNavigate();
  const { t } = useI18n();
  return (
    <div className="relative min-h-[100dvh] bg-[#0A0C0E] text-slate-200">
      <div className="mx-auto w-full max-w-5xl px-5 pb-28 pt-8">{children}</div>

      <nav
        className="fixed inset-x-0 bottom-0 z-40"
        style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
      >
        <div className="mx-auto max-w-md px-5 pb-4">
          <div
            className="flex items-center justify-around rounded-2xl px-2 py-2"
            style={{
              background: "rgba(18,21,25,0.9)",
              border: "1px solid rgba(255,255,255,0.08)",
              backdropFilter: "blur(18px)",
            }}
          >
            {TABS.map((tab) => {
              const Icon = tab.icon;
              const isActive = active === tab.id;
              if (tab.primary) {
                return (
                  <button
                    key={tab.id}
                    data-testid={tab.testId}
                    onClick={() => navigate(tab.to)}
                    className="flex h-12 w-12 items-center justify-center rounded-full transition active:scale-95"
                    style={{
                      background: "linear-gradient(135deg,#FDE68A,#F59E0B 60%,#D97706)",
                      boxShadow: "0 0 20px rgba(245,158,11,0.45)",
                    }}
                    aria-label="Start jam"
                  >
                    <Icon size={22} className="text-[#1a1204]" />
                  </button>
                );
              }
              return (
                <button
                  key={tab.id}
                  data-testid={tab.testId}
                  onClick={() => navigate(tab.to)}
                  className={`flex flex-col items-center gap-1 px-4 py-1 transition ${
                    isActive ? "text-amber-300" : "text-slate-500 hover:text-slate-300"
                  }`}
                >
                  <Icon size={19} />
                  <span className="font-mono text-[9px] uppercase tracking-widest">{t(`nav.${tab.navKey}`)}</span>
                </button>
              );
            })}
          </div>
        </div>
      </nav>
    </div>
  );
};
